import { render, staticRenderFns } from "./registerForDownload.vue?vue&type=template&id=5d4a0dea&scoped=true&"
import script from "./registerForDownload.vue?vue&type=script&lang=js&"
export * from "./registerForDownload.vue?vue&type=script&lang=js&"
import style0 from "./registerForDownload.vue?vue&type=style&index=0&lang=css&"
import style1 from "./registerForDownload.vue?vue&type=style&index=1&id=5d4a0dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4a0dea",
  null
  
)

export default component.exports